<template>
  <div class="filters-container">
    <el-row :gutter="24">
      <custom-input
        v-model.number="filters.Descripcion"
        :label="'Cliente/Prospecto'"
        :spanColumn="4"
        :settings="{
          placeholder: 'Ingresar cliente/prospecto',
        }"
      ></custom-input>
      <custom-input
        v-model.number="filters.CodigoSecundario"
        :label="'Código Adicional'"
        :spanColumn="4"
        :settings="{
          placeholder: 'Ingresar código Adicional',
        }"
      ></custom-input>
      <custom-ejecutivo-filter
        v-model="filters.CodigoEjecutivo"
        :spanColumn="4"
        label="Ejectutivo"
        :settings="{
          placeholder: 'Seleccionar un ejecutivo',
          size: 'default',
          disabled: ejecutivoDisabled,
        }"
      />
      <el-col
        :span="6"
        class="button-container"
      >
        <el-button
          type="primary"
          size="default"
          @click="filtrarProspecto"
          >Filtrar</el-button
        >
        <el-popover
          placement="right"
          :width="40"
          effect="dark"
          trigger="hover"
          content="Limpiar filtros"
        >
          <template #reference>
            <el-button
              type="danger"
              size="default"
              :icon="IconDelete"
              @click="LimpiarFiltros"
            ></el-button>
          </template>
        </el-popover>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import {
  onBeforeMount,
  ref,
} from 'vue';
import CustomInput from '@/shared/components/custom_input.vue';
import CustomEjecutivoFilter from '@/shared/components/custom_ejecutivo_filter.vue';
import { storeToRefs } from 'pinia';
import { useProspectStore } from '../stores/prospect_store.js';
import { useAuthStore } from '@/views/auth/auth_store';
import IconDelete from '~icons/mdi/delete';
const prospectStore = useProspectStore();
const { filters } = storeToRefs(prospectStore);
const { emptyList, findAllProspectsHTTP, setPage, resetFilter } = prospectStore;
const authStore = useAuthStore();
const usuario = authStore.usuario();
const ejecutivoDisabled = ref(false);

const filtrarProspecto = () => {
  try {
    emptyList();
    setPage(1);
    findAllProspectsHTTP();
  } catch (error) {
    console.error('Error al filtrar prospectos:', error);
  }
};

const LimpiarFiltros = () => {
  setPage(1);
  emptyList();
  resetFilter();
  filtrarProspecto();
  initialRol();
};

const initialRol = async () => {
  /* 
    El usuario puede tener varios roles. Si es administrador o presupuestista, puede ver todas las solicitudes y los ejecutivos.
    Si es ejecutivo de ventas (codigo 1), solo lo suyo.
  */

  const esEjecutivoDeVentas = usuario.roles.some((rol) => rol.Codigo === 1);
  if (esEjecutivoDeVentas) {
    ejecutivoDisabled.value = true;
  } else {
    ejecutivoDisabled.value = false;
  }
};

onBeforeMount(() => {
  initialRol();
});
</script>

<style scoped>
.filters-container {
  background-color: white;
  border: 3px solid lightgray;
  padding: 20px;
}

.custom-label {
  font-weight: 700;
  color: #111;
}

.button-container {
  /* Estilo específico para el contenedor del botón */
  margin-top: auto;
  /* Empuja el contenido hacia abajo, ocupando la parte inferior */
}

.margin-row {
  margin-top: 1%;
}
</style>
